import { useTranslation } from '../../i18n/useTranslation'
import { useTheme } from '../../hooks/useTheme'

interface BlockIndexLabelProps {
  index: number
  className?: string
}

/** Muted "Block N" label — distinct from the numbered exercise badges. */
export function BlockIndexLabel({ index, className = '' }: BlockIndexLabelProps) {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <span
      className={`text-[11px] font-semibold tabular-nums ${className}`}
      style={{ color: theme.text.muted }}
    >
      {t.trainingPrograms.blockIndex.replace('{{n}}', String(index))}
    </span>
  )
}
